export default "__VITE_ASSET__3752cbb9__"